import { useEffect, useState } from 'react';
import { v2, type Submission } from '@/api/v2Client';
import { SubmissionWorkspaceTabs } from './SubmissionWorkspaceTabs';
import { SubmissionIdentityHeader } from './SubmissionHeroCard';
import type { Region } from '@/constants/regions';

/** Shared identity for upload and validation deep links. */
export function SubmissionToolHeader({ id }: { id: string }) {
  const [submission, setSubmission] = useState<Submission | null>(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let stale = false;
    setFailed(false);
    v2.submissions.get(id).then((value) => { if (!stale) setSubmission(value); })
      .catch(() => { if (!stale) setFailed(true); });
    return () => { stale = true; };
  }, [id]);
  if (!submission) return failed ? <p role="alert">Submission identity could not be loaded. Return to Submission Details to retry.</p> : <p role="status">Loading submission…</p>;
  return <SubmissionWorkspaceTabs submissionId={id} name={submission.DrugName} sequence={submission.SequenceNumber} active="tool"
    header={<SubmissionIdentityHeader submission={{ ...submission, Region: submission.Region as Region }} showSequence />} />;
}
